module.exports = __webpack_public_path__ + "static/media/Food11.685da525.jpg";